import { useEffect, useMemo } from "react";
import {
  useFetchFWUCampaigns,
  useFetchFWUVersions,
  useFetchNotificationCampaigns,
  useFetchNotifications
} from "../../../apiHooks";
import { campaignStatus } from "../../../consts";

const MAX_ACTIVE_CAMPAIGNS_COUNT = 100;

export const useFetchFWUCampaignData = (marketOption) => {
  const {
    fetchCallback: fetchFWUCampaigns,
    data: fwuCampaigns,
    loading: fwuCampaignsLoading,
    refresh: fwuCampaignsRefresh
  } = useFetchFWUCampaigns(marketOption?.id);

  const {
    fetchCallback: fetchNotifications,
    refresh: notificationsRefresh,
    loading: notificationsLoading
  } = useFetchNotifications();

  const {
    fetchCallback: fetchNotificationCampaigns,
    refresh: notificationCampaignsRefresh,
    loading: notificationCampaignsLoading
  } = useFetchNotificationCampaigns();

  const {
    fetchCallback: fetchFWUVersions,
    data: firmwares,
    loading: fwuVersionsLoading,
    refresh: fwuVersionsRefresh
  } = useFetchFWUVersions();

  const activeFWUCampaignsCount = useMemo(() => {
    if (fwuCampaigns?.length) {
      const total = fwuCampaigns.length;
      const inactive = fwuCampaigns.filter(
        (campaign) => campaign?.status === campaignStatus.inactive
      ).length;

      return total - inactive;
    }

    return 0;
  }, [fwuCampaigns, fwuCampaignsRefresh]);

  const hasMaxActiveFwuCampaigns = useMemo(() => {
    return activeFWUCampaignsCount >= MAX_ACTIVE_CAMPAIGNS_COUNT;
  }, [activeFWUCampaignsCount]);

  useEffect(() => {
    fetchFWUCampaigns(false);
    fetchNotificationCampaigns(false);
    fetchNotifications();
    fetchFWUVersions();
  }, []);

  useEffect(() => {
    if (fwuCampaignsRefresh) {
      fetchFWUCampaigns(true);
    }
  }, [fwuCampaignsRefresh]);

  useEffect(() => {
    if (notificationsRefresh) {
      fetchNotifications(true);
    }
  }, [notificationsRefresh]);

  useEffect(() => {
    if (notificationCampaignsRefresh) {
      fetchNotificationCampaigns(true);
    }
  }, [notificationCampaignsRefresh]);

  useEffect(() => {
    if (fwuVersionsRefresh) {
      fetchFWUVersions(true);
    }
  }, [fwuVersionsRefresh]);

  return {
    fwuCampaigns,
    firmwares,
    activeFWUCampaignsCount,
    hasMaxActiveFwuCampaigns,
    fwuCampaignsLoading,
    notificationsLoading,
    notificationCampaignsLoading,
    fwuVersionsLoading
  };
};
